import { Injectable } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { Observable } from "rxjs/Observable";

import { ActNowDictionaryItem } from "@models/common";

import { environment } from "../../environments/environment";

@Injectable()
export class TypesService {
    public apiUrl: string = environment.apiUrl;
    private headers = new Headers({ "Content-Type": "application/json", "Accept": "application/json;charset=UTF-8" });

    constructor(private http: Http) { }

    getAgencies(): Observable<ActNowDictionaryItem[]> {
        return this.http.get(this.apiUrl + "Types/Agencies", { headers: this.headers })
            .map((response: Response) => <ActNowDictionaryItem[]>response.json())
            .catch(this.handleError);
    }

    createAgency(value: string): Observable<ActNowDictionaryItem> {
        let model = { value: value };
        return this.http.post(this.apiUrl + "Types/Agencies", JSON.stringify(model), { headers: this.headers })
            .map((response: Response) => <ActNowDictionaryItem[]>response.json())
            .catch(this.handleError);
    }

    getCities(): Observable<ActNowDictionaryItem[]> {
        return this.http.get(this.apiUrl + "Types/Cities", { headers: this.headers })
            .map((response: Response) => <ActNowDictionaryItem[]>response.json())
            .catch(this.handleError);
    }

    getPhysicalSettings(): Observable<ActNowDictionaryItem[]> {
        return this.http.get(this.apiUrl + "Types/PhysicalSettings", { headers: this.headers })
            .map((response: Response) => <ActNowDictionaryItem[]>response.json())
            .catch(this.handleError);
    }

    getLicensingOptions(): Observable<ActNowDictionaryItem[]> {
        return this.http.get(this.apiUrl + "Types/LicensingOptions", { headers: this.headers })
            .map((response: Response) => <ActNowDictionaryItem[]>response.json())
            .catch(this.handleError);
    }

    private handleError(error: Response) {
        console.error(error);
        return Observable.throw(error.json() || "Server Error");
    }
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/app/common/types.service.ts